/**
 * APP应用配置
 * @type {{enableAuthPermission: boolean}}
 */
export const APP = {
    /**
     * 是否开启权限控制, 请只在开发调试模式下设为false
     * @type {boolean}
     */
    enableAuthPermission: true,
    polingMessageTime: 10000
}


// WEBPACK FOOTER //
// ./src/config/app.js